// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ivied","top":"styles_top__1pnL9"};